import SectionHeading from "./SectionHeading";
import HeroesArchive from "./HeroesArchive";

const Heroes = ({ characters }) => (
  <section id="heroes" data-testid="heroes-section" className="relative z-10 px-6 py-28 md:px-16 lg:px-24 lg:py-40">
    <SectionHeading
      title="HEROES"
      eyebrow="Every universe is shaped by those who rise to face the unknown. Meet the heroes whose journeys form the heart of the Cosmic Dreams Universe."
    />
    <HeroesArchive characters={characters} />
  </section>
);

export default Heroes;
